import { strIsNullOrEmpty } from '@fox/atoms';
import { Container, Draggable, DropResult } from '@fox/react-smooth-dnd';
import * as React from 'react';
import { memo } from 'react';
import { ColumnHeader } from '../components/common';
import { useDataGridContext } from '../context';
import { TableStyleProps } from '../data-grid';
import { filterColumnsForPosition } from '../helpers';
import { DraggableColumn } from './draggable-column';

const CenterColumnsRender: React.FC<{ hideColumnBorders?: boolean; styles?: TableStyleProps }> = memo(
	props => {
		const { columns } = useDataGridContext();
		const nonFixedColumns = filterColumnsForPosition(columns);

		return (
			<>
				{nonFixedColumns?.map((column, columnIndex) => {
					return (
						<Draggable
							key={!strIsNullOrEmpty(column?.dataIndex) ? column.dataIndex : `centerColumnHeader: ${columnIndex}`}
							render={() => (
								<div className="dragableColumn">
									<DraggableColumn
										styles={props?.styles}
										column={column}
										columnIndex={columnIndex}
										hideColumnBorders={props.hideColumnBorders}
									/>
								</div>
							)}
						/>
					);
				})}
			</>
		);
	},
	() => true
);

export const applyDrag = <T extends unknown>(arr: Array<T>, dragResult: DropResult) => {
	const { removedIndex, addedIndex, payload } = dragResult;
	if (removedIndex === null && addedIndex === null) return arr;

	const result = [...arr];
	let itemToAdd = payload;

	if (removedIndex !== null) {
		itemToAdd = result.splice(removedIndex, 1)[0];
	}

	if (addedIndex !== null) {
		result.splice(addedIndex, 0, itemToAdd);
	}

	return result;
};

export const CenterHeaderColumns: React.FC<{ hasVertScroll: boolean; hideColumnBorders?: boolean; tableStyle?: TableStyleProps }> = props => {
	const { columns, onColumnOrderChanged } = useDataGridContext();

	const handleDrop = (dropResult: DropResult) => {
		const draggables = applyDrag(filterColumnsForPosition(columns), dropResult);

		onColumnOrderChanged(
			[...columns.filter(c => c.fixed === 'left'), ...draggables, ...columns.filter(c => c.fixed === 'right')].filter(
				f => f.dataIndex !== 'leftleft'
			)
		);
	};

	return (
		<div
			style={{
				display: 'flex',
				flexGrow: 1
			}}
		>
			<div>
				<Container
					dragClass=".columndrag"
					getGhostParent={() => document.body}
					onDrop={handleDrop}
					orientation="horizontal"
					dragHandleSelector=".dragHandle"
					lockAxis="x"
					render={rootRef => (
						<div
							ref={rootRef}
							style={{
								display: 'flex',
								overflow: 'hidden'
							}}
						>
							<CenterColumnsRender hideColumnBorders={props.hideColumnBorders} styles={props?.tableStyle} />
						</div>
					)}
				/>
			</div>
			{
				<div style={{ height: '100%', width: '100%', flexGrow: 1, marginRight: props.hasVertScroll ? 20 : -2 }}>
					<ColumnHeader
						style={{ padding: 0 }}
						$hideColumnBorders={props.hideColumnBorders}
						$backgroundColor={props.tableStyle?.headerColour}
					/>
				</div>
			}
		</div>
	);
};
